export const dataTestIds = {
  root: 'template-banner-carousel',
  bannerCarousel: 'banner-carousel',
  mediaItem: 'media-item',
  image: 'carouselImage',
  colorItem: 'color-item',
  mediaIcon: 'media-icon',
};
